var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-bar',{attrs:{"logined":_vm.logined}}),_c('div',{staticClass:"med-wrapper-box"},[_c('router-view',{attrs:{"name":"leftBar"}}),_c('router-view')],1),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }